module.exports = __webpack_public_path__ + "img/music_026.e185853c.png";